import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import eceFacultyData from "./facultyData/eceFacultyData";

const facultyOrder = [
  "f-mahendra-m-dixit",
  "f-plasin-francis-dias",
  "f-a-v-kolaki",
  "f-nikhil-a-kulkarni",
  "f-raghavendra-nagaralli",
  "f-rohini-kallur",
  "f-suraj-kadli",
  "f-deepak-sharma",
  "f-vijayalaxmi-c-kalal",
  "f-pooja-c-shindhe",
  "f-sudheendra-yalagur",
  "f-pavitra-m-badiger",
  "f-ashwini-garaddi",
  "f-rajeshwari-pashupatimath",
  "f-jyoti-kammar",
];

const getOrderedFacultyMembers = (members = []) => [
  ...facultyOrder
    .map((id) => members.find((faculty) => faculty.id === id))
    .filter(Boolean),
  ...members.filter((faculty) => !facultyOrder.includes(faculty.id)),
];

const facultyData = {
  ...eceFacultyData,
  members: getOrderedFacultyMembers(eceFacultyData.members),
};

export const programme = {
  id: "ece",
  name: "Electronics & Communication Engineering",
  short: "E&CE",
  programmeType: "ug",
  programmeLabel: "B.E.",
  duration: "4 Years (8 Semesters)",
  intake: 120,
  // studentsEnrolled: 4000,
  // facultyStrength: 18,
  // phdFaculty: 3,
  established: 2004,
  description: "The Department of Electronics & Communication Engineering (E&CE), established in 2004, offers B.E. and M.Tech. programs and is a VTU-recognized research centre. With experienced faculty, modern laboratories, industry collaborations, and an Advanced Robotics Lab under IIT Bombay’s e-Yantra initiative, the department emphasizes project-based learning, research, and innovation. Students gain strong technical skills and secure placements in leading companies such as Infosys, Wipro, Cadence, and Sankalp Semiconductors.",
  image: "/HomePage/dept/ece.jpeg",
  hodId: "f-nagaraj-bhat",
  facultyData,
  hideSharedClubs: true,
  labs: ["VLSI Lab", "Embedded Systems Lab", "Communication Lab", "DSP Lab"],
  research: "VLSI Design · Wireless Networks · IoT · Image Processing",
  researchFundedProjects: "20+",
  accreditation: ["VTU Recognised Research Centre", "AICTE Approved"],
  achievements: [
    {
      title: "Achievement Documents",
      items: [
        {
          label: "Appreciation Certificate - Mahendra M Dixit",
          href: "/Achievements/ECE/5.-Third-Party-Inspection-1-1-scaled.jpg"
        },
        {
          label: "REXROTH CERTIFICATE",
          href: "/Achievements/ECE/8.-REXROTH_CERTIFICATE.jpeg"
        },
        {
          label: "Trilingual Glossary of Engineering - Mahendra M Dixit",
          href: "/Achievements/ECE/9.-CSTT_APPRECIATION_CERTIFICATE_MMD.jpg"
        },
        {
          label: "Technical Terminology of Engineering - Mahendra M Dixit",
          href: "/Achievements/ECE/10.-Dr.-MMD-MHRD-Certificate_A"
        },
      ],
    },
  ],
  dashboard: [
    ["Faculty Members", "16"],
    ["Faculty with Ph.D.", "03"],
    ["Faculty pursuing Ph.D", "10"],
    ["Laboratories", "07"],
  ],
  academicVision:
    "To bring out talented, skilled, and sustainable Electronics and Communication Engineering Graduates through strong domain expertise to serve the Society with greater Professional Ethics",
  academicOverview: [
    {
      title: "Academic Strengths",
      text: "The E&CE Department is a VTU-recognized Research Centre with a strong academic foundation supported by 18 qualified faculty members, including Ph.D. holders with expertise in Communication Systems, VLSI Design, Embedded Systems, and Signal Processing. The department follows an NBA-aligned Outcome-Based Education framework that promotes research, innovation, and academic excellence.",
    },
    {
      title: "Mission",
      text: [
        "To create and impart an active learning ambience to accomplish a high degree of professional competencies.",
        "To inculcate innovative research and developmental thinking in effective teaching and learning processes for solving societal challenges.",
        "To deliver the needs and requirements of the latest state of art of the industry through quality multidisciplinary internship and training programs.",
      ],
    },
    {
      title: "Beyond Syllabus",
      text: "The E&CE department enhances learning through advanced robotics training (e-Yantra–IIT Bombay), the NVIDIA Centre of Excellence (CoE), industry internships, interdisciplinary projects, industry MoUs, technical and non-technical events, research activities, VLSI and embedded systems exposure, professional development programs, and hands-on learning using advanced hardware and software tools, preparing students for industry, innovation, and emerging technology domains.",
    },
  ],
  curriculumSupport: [
    "VTU-approved curriculum aligned with NBA guidelines and Outcome-Based Education (OBE).",
    "Strong balance of theoretical learning, laboratory practice, and project work.",
    "Internship opportunities help students gain industry exposure in electronics, communication, embedded systems, and allied domains.",
    "Regular workshops and seminars keep students updated with IoT, VLSI, wireless communication, sensors, and emerging technologies.",
    "Value-added courses and certification programs enhance technical skills beyond the university curriculum.",
    // "Industry interactions bridge the gap between academic learning and industry requirements.",
    "Research and innovation opportunities through the VTU-recognized Research Centre.",
    "Continuous mentoring and academic guidance support students' overall growth and success.",
  ],
  programmeOutcomes: [
    "Engineering knowledge: Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.",
    "Problem analysis: Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using the first principles of mathematics, natural sciences, and engineering sciences.",
    "Design/development of solutions: Design solutions for complex engineering problems and design system components or processes that meet the specified needs with appropriate consideration for public health and safety and cultural, societal, and environmental considerations.",
    "Conduct investigations of complex problems: Use research-based knowledge and research methods including design of experiments, analysis, interpretation of data, and synthesis of the information to provide valid conclusions.",
    "The engineer and society: Apply to reason informed by the contextual knowledge to assess societal, health, safety, legal and cultural issues and the consequent responsibilities relevant to the professional engineering practice.",
    "Environment and sustainability: Understand the impact of professional engineering solutions in societal and environmental contexts and demonstrate the knowledge of and need for sustainable development.",
    "Ethics: Apply ethical principles and commit to professional ethics and responsibilities and norms of the engineering practice.",
    "Individual and team work: Function effectively as an individual and as a member or leader in diverse teams and in multidisciplinary settings.",
    "Communication: Communicate effectively on complex engineering activities with the engineering community and with society at large, such as being able to comprehend and write effective reports and design documentation, make effective presentations and give and receive clear instructions.",
    "Project management and finance: Demonstrate knowledge and understanding of the engineering and management principles and apply these to one’s own work, as a member and leader in a team, to manage projects and in multidisciplinary environments.",
    "Recognize the need for lifelong learning and adapt to technological changes in mechanical engineering and allied fields.",
  ],
  pso: [
    "An ability to use appropriate modern techniques for analysis, design and development of VLSI and Embedded Systems",
    "Understand the architectural specifications of a communication system and determine their performance",
  ],
  peo: [
    "To be successful in professional career in electronics, communication and allied industries by acquiring the knowledge in the fundamentals of Electronics and Communication Engineering principles and professional skills",
    "To be in a position to analyze real life problems and design socially accepted and economically feasible solutions in the respective fields.",
    "To exhibit good communication skills in their professional career, lead a team with good leadership traits and good interpersonal relationship with the members related to other engineering streams.",
    "To involve themselves in lifelong learning and professional development by pursuing higher education and participation in research and development activities.",
    "To demonstrate professional and ethical responsibilities towards their profession, society and the environment.",
  ],
  // infrastructure: [
  //   ["Classrooms", "To be updated"],
  //   ["Laboratories", "4"],
  //   ["Computing Facilities", "To be updated"],
  //   ["Project Rooms", "To be updated"],
  //   ["Department Library", "To be updated"],
  //   ["Software Tools", "VLSI, embedded systems, communication, and signal processing tools"],
  //   ["Equipment Highlights", "Laboratories support practical learning in VLSI, embedded systems, communication systems, and DSP."],
  // ],
  studentActivities: {
    clubs: [
      {
        name: "ಸಂವಹನ (Sanvahan)",
        category: "Student Association",
        description: "ಸಂವಹನ (Sanvahan), the student association of the E&CE Department, promotes technical excellence, innovation, leadership, and overall student development. It organizes workshops, expert talks, industry interactions, hackathons, project exhibitions, and technical events, helping students bridge the gap between academics and industry. Through active alumni engagement and student-led initiatives, Sanvahan fosters teamwork, professional growth, and lifelong learning.",
        reports: [
          { title: "Sanvahan Report 1", href: "/student-club/EC&E/ECO/Sanvahan.pdf" },
          // { title: "Sanvahan Report 2", href: "#" },
        ],
      },
    ],
    // professionalChapters: ["IEEE", "IETE", "IEI", "ISTE", "Technical workshops"],
  },
  newsEvents: {
    reports: [
      { label: "Ignite Your Engineering Career Strategies for Success", href: "/EVENTS/EC&E/Ignite-Your-Engineering-Career-Strategies-for-Success.pdf" },
      { label: "ECE CPU Design Using Logisim", href: "/EVENTS/EC&E/ECE_CPU-DESIGN-USING-LOGISIM_9.12.25.pdf" },
    ],
  },
  featuredVideo: {
    title: "Department Video",
    sub: "A message from the Head of Department",
    embedUrl: "https://www.youtube.com/embed/BWqZR-LVASA",
    iframeTitle: "Department Video",
  },

  // facultyTable: [
  //   ["Dr. Nagaraj Bhat", "M.Tech., Ph.D.", "14 years"],
  //   ["Mrs. Rajeshwari Pashupatimath", "M.Tech.", "2years 5 months"],
  //   ["Mr. Raghavendra Nagaralli", "M.Tech.", "13 years"],
  //   ["Ms. Pavitra M Badiger", "M.Tech.", "2.5 years"],
  //   ["Mr. Sudheendra Yalagur", "M.Tech.", "15 years"],
  //   ["Mrs. Ashwini Garaddi", "M.Tech.", "2 years"],
  //   ["Mrs. Jyoti Kammar", "M.Tech.", "1 years"],
  //   ["Mr. Nikhil A. Kulkarni", "M.Tech.", "14 years"],
  //   ["Ms. Pooja C Shindhe", "M.Tech.", "4 years"],
  //   ["Mr. Suraj Kadli", "M.Tech.", "12 years"],
  //   ["Mr. A V Kolaki", "M.Tech.", "26 years"],
  //   ["Dr. Plasin Francis Dias", "M.Tech., Ph.D.", "26 years"],
  //   ["Mrs. Vijayalaxmi C. Kalal", "M.Tech.", "9 years"],
  //   ["Mrs. Rohini Kallur", "M.Tech.", "18 years"],
  //   ["Dr. Mahendra M. Dixit", "M.Tech., Ph.D.", "19 years"],
  //   ["Deepak Sharma", "M.Tech.", "11 years"],
  // ],

  nonTeachingStaff: [
    ["Mr. Karthik N. Konjali", "Foreman"],
    ["Mr. Manjunath M", "Instructor"],
    ["Mr. Jagadeesh Bendigeri", "Instructor"],
    ["Mr. Prashant Shinde", "Asst. Instructor"],
    ["Mr. Kshitij H. Gudihal", "Asst. Instructor"],
    ["Mrs. Shantavaa", "Attender"],
    ["Mr. Arjun Chalavadi", "Peon"],
    ["Mr. Vishwanath Raikar", "Peon"],
    ["Mr. Suresh Madar", "Peon"],
  ],
};

const ECE = () => <ProgrammeDetail programme={programme} />;

export default ECE;
